import { render } from "./WhatsAppPromoCard.vue?vue&type=template&id=f31f7614&scoped=true"
import script from "./WhatsAppPromoCard.vue?vue&type=script&lang=js"
export * from "./WhatsAppPromoCard.vue?vue&type=script&lang=js"

import "./WhatsAppPromoCard.vue?vue&type=style&index=0&id=f31f7614&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f31f7614"]])

export default __exports__